import { render, staticRenderFns } from "./ReminderDialog.vue?vue&type=template&id=68a582c6&scoped=true"
import script from "./ReminderDialog.vue?vue&type=script&lang=js"
export * from "./ReminderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a582c6",
  null
  
)

export default component.exports